<template>
  <div class="wx-weapp-item">
    <template v-if="initSuccess">
      <wx-open-launch-weapp
        :username="username"
        :path="path"
      >
        <script type="text/wxtag-template">
          <style>
          .button {
          background: linear-gradient(90deg, #ECCEA2 0%, #E7B170 100%);
          border-radius: 4px;
          height: 50px;
          width: 100%;
          line-height: 25px;
          color: #fff;
          border: 1px solid #F5C682;
          font-size: 14px;
          }
          .button:active {
          outline: none;
          border-color: transparent;
          box-shadow:none;
          }
          </style>
          <button class="button" type="primary">{{ weappName }}</button>
        </script>
      </wx-open-launch-weapp>
      <div class="wx-weapp-overlay">
        <slot name="button" />
      </div>
    </template>
    <template v-else>
      <van-loading v-if="loading" type="spinner" color="#1989fa" />
      <template v-else>
        <span class="warning">
          <van-icon name="warning-o" size="12px" class="icon" />
          无法打开小程序
        </span>
      </template>
    </template>
  </div>
</template>

<script>
import { getBasisConfigs, settings } from '@/utils/wechat/weapp/config'
const wx = require('weixin-js-sdk')

export default {
  name: 'WxWeappItem',
  props: {
    username: {
      type: String,
      default: 'gh_8e65e8d99361'
    },
    path: {
      type: String,
      default: '/pages/welcome.html'
    },
    weappName: {
      type: String,
      default: '前往小程序'
    }
  },
  data: () => ({
    loading: true,
    initSuccess: false
  }),
  computed: {
  },
  mounted () {
    if (this.isWechat()) {
      this.shareLink = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}${process.env.VUE_APP_BASE_PATH}${decodeURIComponent(this.$route.fullPath)}`
      getBasisConfigs(this.shareLink).then((config) => {
        const { openMap } = settings
        wx.config(Object.assign(config, {
          jsApiList: [''], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          openTagList: [openMap.weapp]
        }))
        console.log({ config })
        this.initWeapp()
      })
    } else {
      this.loading = false
      this.initSuccess = false
    }
  },
  methods: {
    isWechat () {
      let flag = false
      // 获取微信的版本号，如： 7.0.14
      const wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
      if (wechat) {
        flag = true
      }
      return flag
    },
    initWeapp () {
      const vm = this
      wx.ready(function () {
        console.log('开始操作')
        const { openMap } = settings
        wx.checkJsApi({
          jsApiList: [openMap.weapp], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res) {
            vm.initSuccess = true
            vm.loading = false
            console.log('ready', vm.initSuccess, { res })
          },
          fail: (err) => {
            console.log(err, '不可用')
          }
        })
      })
      wx.error(function (error) {
        console.log('not ready', error)
        vm.loading = false
      })
    },
    readyHandler (e) {
      console.log('ready')
    },
    launchHandler (e) {
      console.log('success')
    },
    errorHandler (e) {
      console.log('fail', e.detail)
    }
  }
}
</script>

<style scoped lang="scss">
.wx-weapp-item {
  wx-open-launch-weapp {
    width: 100%;
    height: 50px;
    background-color: pink;
  }
  position: relative;
  .wx-weapp-overlay {
    @include wh(100%, 100%);
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    background: inherit;
  }
  .warning {
    white-space: nowrap;
    color: $color-text-light;
    @include ft(14px, 20px);
  }
}
</style>
